import { Grid } from "@mui/material";
import { useUser } from "../../../hooks/useUser";
import { useNavigate } from "react-router-dom";
import { PageHeader } from "../../shared/PageHeader";
import { GridItemAdd } from "../../shared/addNew/gridItemAdd";
import { AddCircle } from "@mui/icons-material";
import { useLazySearchPartsQuery, useReadUserPartsQuery } from "../../../state/api/parts.api";
import { Part } from "../../../types/Part";
import { PartGridTable } from "../view/partGridTable";
import { useState } from "react";
import { PartsFilterType } from "../../../types/filters/PartsFilterType";
import { TreeSelect } from "../../treeView/TreeView";
import { INode } from "../../../types/INode";
import { partsTypes } from "../../../selectOptions/partsTypes";

export const PartsListOwnerContainer = () => {
    const user = useUser();
    const navigate = useNavigate();
    const [partsFilter, setPartsFilter] = useState<Partial<PartsFilterType>>({});
    const [partNodesArr, setPartNodesArr] = useState<INode[]>(partsTypes);
    const filteredPartTypesNew: INode[] = partNodesArr;


    const [triggerSearch, { data: filterData, error, isFetching }] = useLazySearchPartsQuery();

    const { data: data1 } = useReadUserPartsQuery({ UserId: Number(user.user.id) });

    const handleSelect = (p: Part) => {
        const path = `/sparepart/${p.id}/cache`;
        navigate(path);
    };

    const handleAdd = () => {
        const path = `/sparepart/create`;
        navigate(path);
    }

    const handleCategorySeletionChange = (e: INode[], values: string[]) => {
        if (values.length > 0 && values[0].length > 0) {
            setPartsFilter({
                category: values[0]
            });
            triggerSearch({
                keywords: '',
                limit: 0,
                offset: 0,
                filter: {
                    category: values[0]
                }
            });
        } else {
            setPartsFilter({});
        }
    }

    const renderData = Object.keys(partsFilter).length > 0 ? filterData : data1;

    return <div>
        <PageHeader header={"Your Spare Parts Store"} subHeader={"List of items to sale"} showEditOptions={false} />
        <GridItemAdd Icon={AddCircle} text="Add Sparepart" subText={''} onAdd={handleAdd} />

        <div style={{ background: '#ff00000d', padding: '10px' }}>
            <TreeSelect setNodesArr={setPartNodesArr} isSingleSelection={true} userNodeArr={filteredPartTypesNew} onSelectionChange={handleCategorySeletionChange} />
        </div>

        <Grid container spacing={1}>
            {
                renderData?.map((p: Part) => (
                    <PartGridTable
                        part={p} key={`${p.id}${p.createdAt.toString()}`}
                        onSelect={() => handleSelect(p)} />
                ))
            }
        </Grid>
    </div>
}